/* eslint-disable no-shadow */
import React from 'react';
import PropTypes from 'prop-types';
import { Button, Icon, Card } from 'antd';

class User extends React.Component {
  selectUser = (user) => {
    const { getUserFolderData, setSelectedUser } = this.props;
    getUserFolderData(user.id);
    setSelectedUser(user);
  }

  render() {
    const {
      teamUsers,
      selectedTeamName
    } = this.props;

    return (
      <div >
        <Card
          title={selectedTeamName}
          bordered={false}
          className="full-width"
          bodyStyle={{ minHeight: '150px' }}
        >
          {
            teamUsers.map(user => (
              <Button
                key={user.id}
                className="ml-sm btn-ellipse"
                onClick={() => this.selectUser(user)}
              >
                {user.name}
                <Icon type="swap" />
              </Button>
              ))
          }
        </Card>
      </div>

    );
  }
}
User.defaultProps = {};
User.propTypes = {
  teamUsers: PropTypes.array.isRequired,
  selectedTeamName: PropTypes.string.isRequired,
  getUserFolderData: PropTypes.func.isRequired,
  setSelectedUser: PropTypes.func.isRequired,
};

export default User;




// WEBPACK FOOTER //
// ./src/views/email/emailTemplates/component/user.jsx